import { fetchAppAssignments } from 'api/appAssignments'
import { appAssignmentsStore } from '../model/appAssignmentsStore'

export const refreshAppAssignments = async () => {
	try {
		appAssignmentsStore.lastEtag = null
		const payload = await fetchAppAssignments()
		appAssignmentsStore.setPayload(payload)
	} catch (err) {
		console.error('Failed to refresh app assignments:', err)
	}
}
